<template>
    <div class="row">
        <div class="col-lg-12 m-b-20 client-blacklist-title">
            <!--            <h3>Idenfo Black List Data</h3>-->
            <h3>{{ title }}</h3>
        </div>

        <div class="col-lg-8">
            <b-form v-if="status == 'completed'">
                <base-upload-file
                    :type="type"
                    :upload-file-css="uploadFileCss"
                    :import-file-run="importFileRun"
                    :accept-file="acceptFile"
                    :label-val="'UPLOAD FILES'"
                    @show-progress="showProgress"
                    @uploaded="uploaded"
                >
                    <slot style="z-index: -6">
                        <div class="file-detail">
                            <div class="file-title">
                                <h5>Click here to upload file</h5>
                                <p v-if="type == 'bulkCustomersOnboarding'">
                                    Supported file formats are XLS, XLSX and CSV
                                </p>
                                <p v-else>
                                    Supported file formats are XLS and XLSX
                                </p>
                            </div>
                        </div>
                    </slot>
                </base-upload-file>
                <base-toast></base-toast>
                <div class="file-activity">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <div class="file-progress">
                        <h6>Uploading</h6>
                        <b-progress
                            :value="progressValue"
                            :max="max"
                            class="mb-3"
                        ></b-progress>
                        <span>{{ progressValue }}% completed</span>
                    </div>
                </div>
                <div v-if="type == 'import'" class="file-upload-info">
                    <div class="file-last-update">
                        <p>
                            Last updated on
                            <span>{{
                                updated_date ? updated_date : 'Not updated'
                            }}</span>
                        </p>
                    </div>
                    <div
                        v-if="updated_date && type == 'import'"
                        class="download-current-file"
                    >
                        <button
                            class="btn btn-link"
                            @click.prevent="startDownload()"
                        >
                            <i class="icon-export"></i>

                            <span class="btn-text"
                                >Download Current Data File</span
                            >
                        </button>
                    </div>
                </div>
            </b-form>
            <div v-if="type == 'deltaListUploading'">
                <div
                    v-if="
                        deltaProcessData &&
                        deltaProcessData.processStatus &&
                        deltaProcessData.processStatus !== 'completed'
                    "
                    class="delta-progress-update"
                >
                    <p>
                        Delta Process Status
                        <b style="color: #3c1559">{{
                            deltaProcessData
                                ? deltaProcessData.processStatus
                                : 'Not updated'
                        }}</b>
                        <br />
                        <span v-if="!deltaProcessData.inScreeningData">
                            Process Initated On
                            <b style="color: #3c1559">{{
                                deltaProcessData
                                    ? deltaProcessData.createdAt
                                    : 'Not Available'
                            }}</b>
                        </span>
                    </p>
                    <b v-if="deltaProcessData.inScreeningData">
                        PROCESSING AND UPLOADING FILE INTO DATABASE
                    </b>
                </div>
                <div
                    v-if="
                        deltaProcessData &&
                        deltaProcessData.processStatus &&
                        deltaProcessData.processStatus == 'completed'
                    "
                    class="delta-progress-update"
                >
                    <p>
                        Last Updated On
                        <b style="color: #3c1559">{{
                            deltaProcessData
                                ? deltaProcessData.updatedAt
                                : 'Not Available'
                        }}</b>
                    </p>
                </div>
                <div
                    v-if="
                        deltaProcessData &&
                        deltaProcessData.processStatus !== 'completed' &&
                        type == 'deltaListUploading' &&
                        !deltaProcessData.inScreeningData
                    "
                    class="file-last-update"
                >
                    <span>{{
                        deltaProcessData.completedCustomerCount +
                        ' customers completed out of ' +
                        deltaProcessData.totalCustomerCount
                    }}</span
                    ><br />
                    <b-progress
                        :value="deltaProcessData.completedCustomerCount"
                        :max="deltaProcessData.totalCustomerCount"
                        class="mb-3"
                    ></b-progress
                    ><br />
                    <span
                        >{{
                            (
                                (deltaProcessData.completedCustomerCount /
                                    deltaProcessData.totalCustomerCount) *
                                100
                            ).toFixed(2)
                        }}% completed</span
                    >
                    <span v-if="estimatedTTC !== ''"
                        ><br />Estimated Time To Completion:
                        <b style="color: #3c1559">{{ estimatedTTC }}</b></span
                    >
                </div>
            </div>
            <div
                v-if="updated_date && type == 'bulkCustomersOnboarding'"
                class=""
            >
                <i class="icon-error"></i>
                <button
                    :disabled="loading"
                    class="btn btn-link p-0"
                    @click.prevent="showError()"
                >
                    <span class="btn-text">Show Errors</span>
                </button>
            </div>
            <div v-if="status == 'in-process'" class="upload-files h-100px">
                <div class="file-detail">
                    <div class="file-title">
                        <h5 class="m-b-0px">
                            File in process, you can't upload the file.
                        </h5>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="type == 'import' || type == 'deltaListUploading'"
            class="col-lg-4"
        >
            <div class="download-template">
                <h5>Download Template</h5>
                <p>
                    To upload the black list people records into the system,
                    please download the template file. This will help you
                    understand the fields required. You can fill it up and
                    upload it back into the system.
                </p>
                <div class="link-action">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <a
                        href="/files/delta_template.xlsx"
                        download
                        class="btn btn-link porto-button"
                        >Download Template</a
                    >
                </div>
            </div>
        </div>
        <div v-if="type == 'bulkCustomersOnboarding'" class="col-lg-4">
            <div class="download-template">
                <h5>Download Template</h5>
                <p>
                    To upload bulk customer records into the system, please
                    download the template file. This will help you understand
                    the fields required. You can fill it up and upload it back
                    into the system.
                </p>
                <div class="link-action">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <a
                        :href="templateFilePath"
                        download
                        class="btn btn-link porto-button"
                        >Download Template</a
                    >
                </div>
            </div>
        </div>
        <div class="col-lg-12">
            <!-- When data is loading -->
            <base-table-spinner v-if="showPageLoader"></base-table-spinner>
            <div v-if="isShowError && updated_date">
                <bulk-records
                    :updated-at="updated_date"
                    :bulk-error-records="bulkErrorRecords"
                ></bulk-records>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import excelIcon from '@/components/icons/ExcelIcon.vue'
import bulkRecords from '@/components/BulkRecords.vue'
import resource from '@/api/resource'
//import black from '@/components/icons/Black.json'
import axios from 'axios'
const apiUrl_data = process.env.VUE_APP_API_URL
const headers = {
    Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
}
export default {
    components: {
        excelIcon,
        bulkRecords,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            default: 'Idenfo Black List Data',
        },
        type: {
            default: 'import',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            uploadFileCss: true,
            blacklist: false,
            progressValue: 0,
            max: 100,
            form: {
                file: null,
            },
            updated_date: null,
            url: '',
            import_statistics_data: '',
            DowmLoadFileName: '',
            status: '',
            importFileRun: true,
            acceptFile: '.xlsx,.csv,.xls',
            bulkErrorRecords: [],
            isShowError: false,
            disabled: false,
            deltaProcessData: null,
            intervalId: true,
            estimatedTTC: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'user',
            'dataSegmentId',
            'formBuilderList',
            'loading',
            'showPageLoader',
        ]),
        templateFilePath(){
            return localStorage.getItem("dataSegmentType") && localStorage.getItem("dataSegmentType").trim() == "Corporate" ? "/files/templateBulkCorporate.xlsx" : "/files/templateBulk.xlsx"
        }

        // updated_date(value){
        //     console.log("upd date ", value)
        //     return value
        // }
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$store.commit('showPageLoader', true)

                this.importStatisticsData()
                if (this.progressValue == 100) {
                    this.importBulkCustomers()
                }
            }
        },
        //  updated_date(value){
        //       this.importStatisticsData()
        //     console.log("upd date ", value)

        //     return value
        // }
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.$store.commit('showPageLoader', true)
        this.importDeltaStatusProgress()
        this.importStatisticsData()
    }, // End of Component > computed
    beforeDestroy: function () {
        console.log('beforeDestroy()')
        this.intervalId = false
    },

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        uploaded(value) {
            console.log('emit ', value)
            if (value) {
                this.importBulkCustomers()
            }
            if (this.type == 'deltaListUploading') {
                this.importDeltaStatusProgress()
            }
        },
        showProgress(value) {
            this.progressValue = value
            if (this.type == 'bulkCustomersOnboarding') {
                this.$emit('show-progress', value)
            }
        },

        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', this.DowmLoadFileName)
            document.body.appendChild(link)
            link.click()
        },

        startDownload() {
            axios({
                method: 'get',
                url: this.url,
                responseType: 'arraybuffer',
                headers: headers,
            })
                .then((response) => {
                    this.forceFileDownload(response)
                })
                .catch(() => console.log('error occured'))
        },

        async importStatisticsData() {
            let dataSegmentId = this.dataSegmentId
            if (dataSegmentId) {
                if (
                    this.type !== 'bulkCustomersOnboarding' &&
                    this.type !== 'deltaListUploading'
                ) {
                    try {
                        let response = await axios.get(
                            apiUrl_data +
                                'screening-data/import-statistics/' +
                                dataSegmentId,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                        this.updated_date = response.data.data.lastUpdatedAt
                        this.url = response.data.data.fileURL
                        this.DowmLoadFileName = response.data.data.fileName
                        this.status = response.data.data.status
                    } catch (e) {
                        this.updated_date = null
                        this.url = ''
                        this.DowmLoadFileName = ''
                        this.status = 'completed'
                    }
                } else {
                    this.importBulkCustomers()
                }

                this.updated_date = null
                this.url = ''
                this.DowmLoadFileName = ''
                this.status = 'completed'
            }

            this.$store.commit('showPageLoader', false)
        },
        async importBulkCustomers() {
            if (this.type == 'bulkCustomersOnboarding') {
                try {
                    const page = this.$store.getters.getField(
                        'pagination.' + 'customers/import-bulk-customers/'
                    )
                    let data = await axios.get(
                        apiUrl_data +
                            'customers/import-bulk-customers/' +
                            this.dataSegmentId,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                            params: {
                                startAt: 1,
                                keyword: '',
                                perPage: page ? page : 10,
                            },
                        }
                    )

                    if (data && data.data && data.data.data) {
                        // console.log('data ', data)
                        this.updated_date = data.data.data[0].createdAt

                        this.bulkErrorRecords = data.data.data.map((ele) => {
                            return ele.info
                        })
                        // this.$store.dispatch(`setData`, data.data)
                        this.status = 'completed'
                    }
                } catch (e) {
                    console.log(e)
                }
            }
        },
        async importDeltaStatusProgress() {
            if (this.type == 'deltaListUploading') {
                try {
                    let response = await axios.get(
                        apiUrl_data + 'screening-data/returnDeltaStatus',
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                        }
                    )
                    if (!response.data.data.message) {
                        this.deltaProcessData = response.data.data
                        this.status = response.data.data.processStatus
                            ? response.data.data.processStatus
                            : 'Completed'
                        if (
                            response.data.data.processStatus == 'in-progress' &&
                            this.intervalId
                        ) {
                            if (
                                response.data.data.inScreeningData &&
                                response.data.data.errorLog == ''
                            ) {
                            } else if (
                                !response.data.data.inScreeningData &&
                                response.data.data.errorLog != ''
                            ) {
                            } else {
                                let totalTimeMs =
                                    this.deltaProcessData.averageTimeMs *
                                    (this.deltaProcessData.totalCustomerCount -
                                        this.deltaProcessData
                                            .completedCustomerCount)
                                this.estimatedTTC = this.msToTime(totalTimeMs)
                            }
                            setTimeout(() => {
                                this.importDeltaStatusProgress()
                            }, 500)
                        }
                    } else {
                        this.deltaProcessData = null
                    }
                } catch (e) {
                    this.deltaProcessData = null
                }
            }
        },
        msToTime(duration) {
            var seconds = Math.floor((duration / 1000) % 60),
                minutes = Math.floor((duration / (1000 * 60)) % 60),
                hours = Math.floor((duration / (1000 * 60 * 60)) % 24)
            hours = hours < 10 ? '0' + hours : hours
            minutes = minutes < 10 ? '0' + minutes : minutes
            seconds = seconds < 10 ? '0' + seconds : seconds
            return hours + ':' + minutes + ':' + seconds
        },

        showError() {
            this.importBulkCustomers()
            this.isShowError = !this.isShowError
        },
    }, // End of Component > watch
} // End of export default
</script>
